import React from 'react';

class Footer extends React.Component {
  render() {
    return false;
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/ui/layout/Footer/index.js